const DRAG_THRESHOLD = 10;

    const pendingPillPositions = new Map();
    let pillPositionFrame = 0;

    function restorePillTransitions(pills) {
        pills.forEach(function (pill) { pill.style.transition = ''; });
    }

    function flushPillPositions() {
        pillPositionFrame = 0;
        const updates = Array.from(pendingPillPositions, function ([pill, request]) {
            return { pill, animate: request.animate, width: request.activeBtn.offsetWidth, left: request.activeBtn.offsetLeft };
        });
        pendingPillPositions.clear();
        updates.forEach(function (update) {
            if (!update.animate) update.pill.style.transition = 'none';
            update.pill.style.width = update.width + 'px';
            update.pill.style.left = update.left + 'px';
        });
        const instantPills = updates.filter(function (update) { return !update.animate; }).map(function (update) { return update.pill; });
        if (instantPills.length) requestAnimationFrame(function () { restorePillTransitions(instantPills); });
    }

    function updatePillPosition(pill, activeBtn, animate) {
        if (animate === undefined) animate = true;
        if (!activeBtn || !pill) return;
        pendingPillPositions.set(pill, { activeBtn, animate });
        if (!pillPositionFrame) pillPositionFrame = requestAnimationFrame(flushPillPositions);
    }

    function getButtonAtPosition(buttons, clientX) {
        return Array.from(buttons).find(btn => {
            const rect = btn.getBoundingClientRect();
            return clientX >= rect.left && clientX <= rect.right;
        });
    }

    function dispatchFilterChanged(wrapper, value) {
        wrapper.dispatchEvent(new CustomEvent('filter-changed', {
            detail: { value: value, id: wrapper.id },
            bubbles: true
        }));
    }

    function scheduleFilterChanged(wrapper, value) {
        requestAnimationFrame(function () {
            dispatchFilterChanged(wrapper, value);
        });
    }

    function applyActiveButton(buttons, targetBtn, pill, animate) {
        buttons.forEach(function (b) { b.classList.remove('active'); });
        targetBtn.classList.add('active');
        updatePillPosition(pill, targetBtn, animate);
    }

    function setSlidingFilterValue(wrapper, value, options) {
        options = options || {};
        if (!wrapper?.classList?.contains('sliding-filter-wrapper')) return false;
        const pill = wrapper.querySelector('.sliding-filter-pill');
        const buttons = wrapper.querySelectorAll('.sliding-filter-btn');
        const normalized = value == null ? '' : String(value);
        const targetBtn = wrapper.querySelector('.sliding-filter-btn[data-value="' + normalized + '"]')
            || wrapper.querySelector('.sliding-filter-btn[data-value=""]')
            || buttons[0];
        if (!targetBtn || !pill) return false;
        applyActiveButton(buttons, targetBtn, pill, options.animate !== false);
        return true;
    }

    function syncSlidingFilterWrappers(wrapperIds, value, sourceWrapperId) {
        if (!Array.isArray(wrapperIds)) return;
        wrapperIds.forEach(function (id) {
            if (id === sourceWrapperId) return;
            const wrapper = document.getElementById(id);
            if (!wrapper) return;
            setSlidingFilterValue(wrapper, value, { animate: false });
        });
    }

    function setActiveButton(buttons, targetBtn, pill, wrapper, shouldDispatch) {
        if (shouldDispatch === undefined) shouldDispatch = true;
        const wasActive = targetBtn.classList.contains('active');
        if (wasActive && shouldDispatch) return;

        applyActiveButton(buttons, targetBtn, pill, true);

        if (shouldDispatch) scheduleFilterChanged(wrapper, targetBtn.dataset.value);
    }

    function initTouchHandlers(wrapper, pill, buttons, dragState) {
        let touchStartX = null;
        let lastActiveBtn = null;

        wrapper.addEventListener('touchstart', function(e) {
            touchStartX = e.touches[0].clientX;
            dragState.isDragging = false;
            lastActiveBtn = wrapper.querySelector('.sliding-filter-btn.active');
        });

        wrapper.addEventListener('touchmove', function(e) {
            if (touchStartX === null) return;

            const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
            if (deltaX > DRAG_THRESHOLD) {
                dragState.isDragging = true;
                const targetBtn = getButtonAtPosition(buttons, e.touches[0].clientX);
                if (targetBtn) {
                    setActiveButton(buttons, targetBtn, pill, wrapper, false);
                    lastActiveBtn = targetBtn;
                }
            }
        });

        wrapper.addEventListener('touchend', function(e) {
            if (touchStartX === null) return;

            if (dragState.isDragging && lastActiveBtn) {
                const endBtn = getButtonAtPosition(buttons, e.changedTouches[0].clientX) || lastActiveBtn;
                applyActiveButton(buttons, endBtn, pill, true);
                scheduleFilterChanged(wrapper, endBtn.dataset.value);
            }

            touchStartX = null;
            lastActiveBtn = null;
            setTimeout(() => { dragState.isDragging = false; }, 100);
        });
    }

    function initFilter(wrapper) {
        if (wrapper.dataset.initialized) return;
        wrapper.dataset.initialized = 'true';

        const pill = wrapper.querySelector('.sliding-filter-pill');
        const buttons = wrapper.querySelectorAll('.sliding-filter-btn');
        const dragState = { isDragging: false };

        buttons.forEach(btn => {
            btn.addEventListener('click', function() {
                if (dragState.isDragging) return;
                setActiveButton(buttons, this, pill, wrapper, true);
            });
        });

        initTouchHandlers(wrapper, pill, buttons, dragState);

        setTimeout(() => {
            const activeBtn = wrapper.querySelector('.sliding-filter-btn.active') || buttons[0];
            updatePillPosition(pill, activeBtn, false);
        }, 50);

        if (document.fonts?.ready) {
            document.fonts.ready.then(() => {
                const activeBtn = wrapper.querySelector('.sliding-filter-btn.active') || buttons[0];
                updatePillPosition(pill, activeBtn, false);
            });
        }
    }

    function refreshPillPosition(wrapper) {
        if (!wrapper?.classList?.contains('sliding-filter-wrapper')) return;
        const pill = wrapper.querySelector('.sliding-filter-pill');
        const activeBtn = wrapper.querySelector('.sliding-filter-btn.active');
        if (pill && activeBtn) updatePillPosition(pill, activeBtn, false);
    }

    function initAllFilters() {
        document.querySelectorAll('.sliding-filter-wrapper').forEach(initFilter);
    }

    function onWindowResize() {
        document.querySelectorAll('.sliding-filter-wrapper').forEach(refreshPillPosition);
    }

    if (document.documentElement.dataset.slidingFilterViewSync !== '1') {
        document.documentElement.dataset.slidingFilterViewSync = '1';
        document.addEventListener('mfb:view-opened', function (event) {
            event.target.querySelectorAll('.sliding-filter-wrapper').forEach(refreshPillPosition);
        });
        window.addEventListener('resize', onWindowResize);
    }

export const reinitSlidingFilters = initAllFilters;
export const refreshSlidingFilterPill = refreshPillPosition;
export { setSlidingFilterValue, syncSlidingFilterWrappers };
